import { useFormContext } from 'react-hook-form';

import { type DateTimeField } from '@/types/schema/fields';
import { type KnackField } from '@/types/schema/KnackField';
import { type FormViewDateTimeInput } from '@/types/schema/views/form/DateTime';
import { type FormView } from '@/types/schema/views/FormView';
import { useFormRecordValues } from '@/hooks/useFormRecordValues';
import { FormErrorMessage } from '@/components/errors/FormErrorMessage';
import { KnackDatePickerChildForm } from '@/components/knack-date-picker/KnackDatePickerChildForm';
import { useViewContext } from '@/components/views/ViewContext';

export function DateTimeInput({
  input,
  isReadOnly,
  field
}: {
  input: FormViewDateTimeInput;
  isReadOnly?: boolean;
  field: KnackField;
}) {
  const {
    getValues,
    formState: { errors }
  } = useFormContext();

  // To render the value in read-only mode, we need to get the record values from the form context
  const { view } = useViewContext<FormView>();
  const { recordValues } = useFormRecordValues(view);

  return (
    <>
      {isReadOnly && (
        <div className="text-muted-foreground mb-2 text-sm">
          <p className="truncate">{recordValues?.values?.[input.field.key]}</p>
        </div>
      )}
      {!isReadOnly && (
        <KnackDatePickerChildForm
          formPath={input.field.key}
          dateTimeField={field as DateTimeField}
          value={getValues(input.field.key)}
        />
      )}
      <FormErrorMessage errors={errors} name={input.field.key} />
    </>
  );
}
